// extracted by mini-css-extract-plugin
module.exports = {"actions":"invoicesChanges-actions_actions__3r4mP"};